/** 全屏/区域加载态。 */
export interface SpinnerProps {
  size?: number;
  className?: string;
}

export function Spinner({ size = 16, className = '' }: SpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-label="加载中"
      className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

/** 全屏/区域加载态。 */
export function LoadingBlock({ text = '加载中…' }: { text?: string }): JSX.Element {
  return (
    <div className="flex items-center justify-center gap-2 py-10 text-dim">
      <Spinner />
      <span className="text-sm">{text}</span>
    </div>
  );
}

export default Spinner;
